export enum UserCertificateStatus {
  CREATED = 'created',
  REVOKED = 'revoked',
}
